<div class="not-found">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-12 col-md-10 offset-md-1 col-lg-4 offset-lg-1">
        <div class="not-found__title" #titleEl>
          <em>404</em> – Seite <br/>nicht gefunden
        </div>

        <div class="not-found__text not-found__text--desktop">
          Leider existiert die von Ihnen gesuchte Seite nicht oder es ist ein anderer Fehler aufgetreten.
        </div>

        <a [routerLink]="routerLink" class="not-found__link not-found__link--desktop">
          <brt-button color="red" [title]="'Zur Startseite'" size="large" [type]="'link'"></brt-button>
        </a>
      </div>

      <div class="col-12 col-md-10 offset-md-1 col-lg-4 offset-lg-2">
        <div class="not-found__animation">
          <brt-lottie [lottieOptions]="{autoplay: true, loop: true, path: '/assets/lottie-animations/quiz/BFR-Illustration-2.json'}"></brt-lottie>
        </div>

        <div class="not-found__text not-found__text--mobile">
          Leider existiert die von Ihnen gesuchte Seite nicht oder es ist ein anderer Fehler aufgetreten.
        </div>

        <a [routerLink]="routerLink" class="not-found__link not-found__link--mobile">
          <brt-button color="red" [title]="'Zur Startseite'" size="large" [type]="'link'"></brt-button>
        </a>
      </div>
    </div>
  </div>
</div>
